import "antd/dist/antd.css";

import { ButtonOne, People } from "./Buttons";
import React, { useState } from "react";

import Avatar1 from "../assets/avatar-2.png";
import Avatar2 from "../assets/avatar-1.png";
import Radium from "radium";
import United from "../assets/united.png";
import { useNavigate } from "react-router-dom";

const CommunitiesCard = ({
  img,
  setModalOpen,
  funded,
  title,
  category,
  reward,
  currentFunding,
  fundingGoal,
}) => {
  const [onSubmit, setOnSubmit] = useState(false);
  const navigate = useNavigate();

  return (
    <article style={styles.communitiesCard}>
      <section style={styles.communitiesCard.info}>
        <div style={styles.communitiesCard.info.itemOne}>
          <div
            style={styles.communitiesCard.info.itemOne.text}
            onClick={() => navigate(`/community/${title}`)}
          >
            <div
              style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}
            >
              <div style={styles.communitiesCard.imgContainer}>
                <img
                  src={img}
                  style={styles.communitiesCard.imgContainer.img}
                  alt="comunidad"
                  width={"50px"}
                />
              </div>
              <p style={styles.communitiesCard.info.itemOne.text.p1}>{title}</p>
            </div>

            <p style={styles.communitiesCard.info.itemOne.text.p2}>Por {category}</p>
          </div>
          <ButtonOne
            text={"+Unirse"}
            style={{
              fontWeight: "600",
              color: "#78D504",
              backgroundColor: "white",
              fontSize: "16px",
            }}
            onClick={() => setModalOpen(true)}
          />
        </div>

        <div
          style={styles.communitiesCard.info.itemTwo}
          onClick={() => navigate(`/community/${title}`)}
        >
          <div style={styles.communitiesCard.info.reward}>
            <div style={styles.communitiesCard.info.itemTwo.text}>
              <img src={United} width={30} alt="" />
              <p style={styles.communitiesCard.info.itemTwo.text.p}>2 Desafíos</p>
            </div>
          </div>
          <People circleSize={20} imgOne={Avatar1} imgTwo={Avatar2} textThree={"18k+"} />
        </div>
      </section>
    </article>
  );
};

export default Radium(CommunitiesCard);

const query = {
  small: "@media (max-width: 600px)",
  medium: "@media (max-width: 1440px)",
  large: "@media (max-width: 1700px)",
};

const styles = {
  communitiesCard: {
    display: "flex",
    flexDirection: "column",
    width: "330px",
    height: "fit-content",
    backgroundColor: "white",
    borderRadius: "20px",
    padding: "16px",
    [query.large]: { width: "280px" },
    imgContainer: {
      display: "flex",
      width: "55px",
      height: "50px",
      alignItems: "center",
      justifyContent: "center",
      img: { borderRadius: "50px" },
    },

    info: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      itemOne: {
        display: "flex",
        justifyContent: "space-between",
        text: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          p1: {
            fontSize: "16px",
            margin: 0,
            fontWeight: "600",
          },
          p2: {
            fontSize: "14px",
            color: "#A3AED0",
            margin: 0,
          },
        },
      },
      itemTwo: {
        display: "flex",
        justifyContent: "space-between",
        text: {
          display: "flex",
          alignItems: "center",
          p: {
            fontSize: "16px",
            fontWeight: "500",
            margin: 0,
          },
        },
      },
      reward: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  },

  sliderContainer: {
    width: "100%",
    height: "10px",
    sliderComponent: {
      justifyContent: "center",
      handleStyle: {
        backgroundColor: "#78D504",
        borderColor: "white",
      },
      trackStyle: { backgroundColor: "#78D504", height: "6px" },
    },
  },
  buttonContainer: {
    display: "flex",
    backgroundColor: "#78D504",
    borderRadius: "70px",
    border: 0,
    color: "white",
    fontWeight: "600",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
  },
};
